import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Person, CalendarToday, Description } from '@mui/icons-material';
import {
  DOCUMENT_VIEW_DIALOG_STYLES,
  UPLOAD_DIALOG_COLORS,
  formatDate,
} from '../../../../../common/styles/dialogStyles';
import { WriteoffDocumentView } from '../../../../../../services/WriteoffService/types/documentTypes';

interface DocumentInfoProps {
  document: WriteoffDocumentView;
}

export const DocumentInfo: React.FC<DocumentInfoProps> = ({ document }) => (
  <Box sx={DOCUMENT_VIEW_DIALOG_STYLES.card}>
    <Typography
      variant="subtitle2"
      sx={{ fontWeight: 600, mb: 2, color: UPLOAD_DIALOG_COLORS.textPrimary }}
    >
      Document Information
    </Typography>
    <Stack spacing={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Person sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, fontSize: 20 }} />
        <Typography
          variant="body2"
          sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, fontWeight: 500 }}
        >
          Uploaded by:
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {document.uploadedBy || 'Unknown User'}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <CalendarToday sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, fontSize: 20 }} />
        <Typography
          variant="body2"
          sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, fontWeight: 500 }}
        >
          Upload date:
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {formatDate(document.uploadedDate)}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Description sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, fontSize: 20 }} />
        <Typography
          variant="body2"
          sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, fontWeight: 500 }}
        >
          Storage path:
        </Typography>
        <Typography variant="body2" sx={DOCUMENT_VIEW_DIALOG_STYLES.codePath}>
          {`writeoffs/${document.writeoffId}/${document.fileName}`}
        </Typography>
      </Box>
    </Stack>
  </Box>
);

export default DocumentInfo;
